import apiClient from './apiClient';

export const regionService = {
    // Get all regions
    getAllRegions: async (params = {}) => {
        try {
            const response = await apiClient.get('/regions', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get single region by ID
    getRegion: async (id) => {
        try {
            const response = await apiClient.get(`/regions/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Create new region
    createRegion: async (regionData) => {
        try {
            const response = await apiClient.post('/regions', regionData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Update region
    updateRegion: async (id, regionData) => {
        try {
            const response = await apiClient.put(`/regions/${id}`, regionData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Delete region
    deleteRegion: async (id) => {
        try {
            const response = await apiClient.delete(`/regions/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get region statistics
    getRegionStats: async () => {
        try {
            const response = await apiClient.get('/regions-data/stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get available cities for a region
    getAvailableCities: async (regionId) => {
        try {
            const response = await apiClient.get(`/regions/${regionId}/available-cities`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Validate city assignments
    validateCityAssignments: async (cityIds, regionId) => {
        try {
            const response = await apiClient.post(`/regions/validate-city-assignments`, {
                city_ids: cityIds,
                region_id: regionId
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Assign cities to region
    assignCities: async (regionId, cityIds) => {
        try {
            const response = await apiClient.post(`/regions/${regionId}/assign-cities`, {
                city_ids: cityIds
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get all unassigned cities (for new region creation)
    getUnassignedCities: async () => {
        try {
            const response = await apiClient.get('/regions-data/unassigned-cities');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};

export default regionService; 